<template>
	<div>
		
		<tableBox  :url="'/Flat/UserResearchgroup'" :notSearch="true"     :columns="columns"></tableBox>
	</div>
</template>

<script>
	import tableBox from '../../../components/tableBox.vue'
	export default {
		name:'/core/research',
		components: {
			tableBox
		},
		data() {
			return {

				columns: [{
						title: '课题组名称',
						dataIndex: 'groupName',
						key: 'groupName',
					},
					{
						title: '课题组经费（元）',
						dataIndex: 'fundses',
						key: 'fundses',
						scopedSlots: {
							customRender: 'fundses'
						},
					},
					{
						title: '成员',
						dataIndex: 'members',
						key: 'members',
						scopedSlots: {
							customRender: 'members'
						},

					},
					{
						title: '创建时间',
						dataIndex: 'createTime',
						key: 'createTime'

					},
					{
						title: '加入时间',
						dataIndex: 'members',
						key: 'members',
						scopedSlots: {
							customRender: 'addTimes'
						},

					},
					{
						title: '操作',
						dataIndex: 'researchOperation',
						scopedSlots: {
							customRender: 'researchOperation'
						},
					},
				],
				
			}
		}
	};
</script>

<style>
</style>
